import React, {Component, Fragment} from 'react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {route} from "../../../routes";
import {
  GelContentContainer,
  GelContentRow,
  FormBack,
  InfographicCard,
  StatCard,
  Utility,
  Link,
  Highlight,
  Sanitize
} from 'cw-styleguide-react';
import Helmet from 'react-helmet';
import SecondaryAutocompleteSearch from "../../../components/SecondaryAutocompleteSearch";

class JobBecome extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} - {this.props.t('route_become_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('job', {job: this.props.data.slug}) + '/' + route('jobBecome')}>
          {this.props.t('route_become_title')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('route_become_title')}</h1>

          {!!this.props.data.healthConsiderations.text &&
            <GelContentRow>

              {/* Health */}
              <StatCard
                width={100}
                colour={'brand-d'}
                title={this.props.t('health_considerations_title')}
                rows={[
                  {
                    icon: 'health', text: <Fragment>
                      <p><Sanitize html={this.props.data.healthConsiderations.preText}/></p>
                      <p><strong>{this.props.data.healthConsiderations.text.join(', ')}</strong></p>
                      <p><Sanitize html={this.props.data.healthConsiderations.postText}/></p>
                    </Fragment>
                  }
                ]}
              />

            </GelContentRow>
          }

          <Sanitize html={this.props.data.howToBecomeData.text} classes={['style--list-circle', 'style--list-no-bg']}/>
          <h3 id={Utility.slug(this.props.t('qualifications_title'))}>{this.props.t('qualifications_title')}</h3>
          <GelContentRow>

            {/* Qualifications */}
            {!!this.props.data.qualifications.qualification &&
              <StatCard
                link={false}
                width={100}
                colour={'brand-d'}
                size="large"
                title={this.props.t('qualifications_title')}
                rows={[
                  {
                    icon: 'qualification',
                    text: Object.values(this.props.data.qualifications.qualification).join(' ' + this.props.t('view.jobDetail.pay.upTo') + ' ')
                  }
                ]}
              />
            }

          </GelContentRow>
          <Sanitize html={this.props.data.qualifications.text} classes={['style--list-circle', 'style--list-no-bg']}/>


          <Fragment>
            <h3 id={Utility.slug(this.props.t('future_demand_title'))}>
              {this.props.t('future_demand_title')}
            </h3>
            <GelContentRow>

              {/* Openings */}
              <InfographicCard
                link={false}
                size={'large'}
                colour={'brand-f'}
                title={this.props.data.openingsData.text}
                source={"https://publicfiles.careerswales.gov.wales/jobs/job-information/content/d7-info-graphic.jpg"}
                stat={this.props.data.openingsData.value && {counter: this.props.data.openingsData.value}}
                classes={['card--option', 'infographic--lmi']}
              >
                <p>{this.props.data.lightcastRefYear}</p>
              </InfographicCard>

              {/* Demand */}
              <StatCard
                width={100}
                size={'large'}
                colour={'brand-a'}
                rows={[
                  {
                    icon: 'chart', figure: this.props.data.futureDemand.trend, text:
                      <Fragment>
                        <p>{this.props.data.futureDemand.text}</p>
                        <p>{this.props.data.lightcastRefYear}</p>
                      </Fragment>
                  }
                ]}
                classes={['card--option']}
              />

            </GelContentRow>
          </Fragment>

          {/* Statistics @todo emsi */}
          {this.props.data.numberEmployed.text &&
            <Highlight>
              <ul className={'style--list-circle style--list-no-bg'}>
                <li>
                  <Sanitize html={this.props.data.numberEmployed.text}/>
                </li>
              </ul>
              <p>{this.props.data.lightcastRefYear}</p>
            </Highlight>
          }

          <hr/>
          <h3 id={Utility.slug(this.props.t('more_information_title'))}>
            {this.props.t('more_information_title')}
          </h3>
          <ul className="style style--list-large">
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobRole')}>
                {this.props.t('route_role_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobPay')}>
                {this.props.t('route_pay_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobSkills')}>
                {this.props.t('route_skills_title')}
              </Link>
            </li>
          </ul>
          <FormBack url={route('job', {job: this.props.data.slug})} title={this.props.data.name}/>
          <hr className="thick"/>
          <SecondaryAutocompleteSearch jobs={this.props.jobs}/>
        </GelContentContainer>
      </Fragment>
    )
  }
}

export default withTranslation('local')(JobBecome);
